import { render } from "./AccordionContainer.vue?vue&type=template&id=53c1f478&scoped=true"
const script = {}

import "./AccordionContainer.vue?vue&type=style&index=0&id=53c1f478&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c1f478"]])

export default __exports__